import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { EmployeeService } from '../services/employee.service';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class RestrictedAccessGuard implements CanActivate {
  constructor(
    private employeeService: EmployeeService,
    private router: Router
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    const checkKey = next.data?.['checkKey'] as string;
    const disallowIncludes = next.data?.['disallowIncludes'] as string;
    const redirectTo = next.data?.['redirectTo'] as string || '/learning-center';

    if (!checkKey || !disallowIncludes) {
      console.error('RestrictedAccessGuard: Missing required configuration (checkKey or disallowIncludes)');
      return of(this.router.createUrlTree([redirectTo]));
    }

    return this.employeeService.me().pipe(
      map(profile => {
        if (!profile || !profile.hasOwnProperty(checkKey)) {
          console.warn(`RestrictedAccessGuard: Property '${checkKey}' not found in profile`);
          return this.router.createUrlTree([redirectTo]);
        }

        const value = profile[checkKey];

        if (typeof value === 'string' && value.toLowerCase().includes(disallowIncludes.toLowerCase())) {
          console.log(`RestrictedAccessGuard: Access denied for ${checkKey}: ${value}`);
          return this.router.createUrlTree([redirectTo]);
        }

        return true;
      }),
      catchError((error) => {
        console.error('RestrictedAccessGuard: Error fetching profile', error);
        return of(this.router.createUrlTree([redirectTo]));
      })
    );
  }
}

export interface RestrictedAccessGuardData {
  checkKey: string;
  disallowIncludes: string;
  redirectTo?: string;
}
